import { reportValidationError } from 'src/dataLayer/remoteData/rollbar/reportAPIErrors.ts';
import {
  LOCALE,
  RUNTIME_ENVIRONMENT
} from 'src/dataLayer/env';
import { isInvalidLearnLang } from 'src/viewLayer/helpers/validateLearnLang.ts';

export default ({
  name,
  version,
  learnLang
}) => {
  if (
    name &&
    Number(version) &&
    (!learnLang || !isInvalidLearnLang(learnLang))
  ) return true;

  if (RUNTIME_ENVIRONMENT !== 'production') {
    // eslint-disable-next-line no-console
    console.error(`
      Attempted to emit an event to Babbel Event Stream, but was either missing a required or contained an invalid prop:
        - name: ${name}
        - version: ${version}
        - locale: ${LOCALE}
        ${learnLang ? `- learnLanguageCode:${learnLang}` : '' }
    `);
  }

  reportValidationError('validationError', name, {
    learnLanguageCode: learnLang, locale: LOCALE, version
  });

  return false;
};
